import { gql } from "@apollo/client";

export default gql`
  mutation createAnnouncementCategory($input: CreateChangelogCategoryInput!){
    createAnnouncementCategory(input: $input){
        success
        data{
            _id
            color
            translations
            createdAt
            updatedAt
        }
        error
        message
    }
}
`
